<template>
  <div>
    <template v-if="loading">
      <content-placeholders>
        <content-placeholders-text :lines="3"/>
      </content-placeholders>
    </template>
    <div class="catalog-view__videos-row" id="videos" v-if="show">
      <div class="catalog-view__videos-tab">
        <div class="video-tab" v-if="youtube.length > 0" :class="activeTab === 0 ? 'active-tab' : ''" @click="setActive(0)">
          <span class="video-tab__count">{{ youtube.length }}</span><span
            class="video-tab__label">YouTube</span>
        </div>
        <div class="video-tab" v-if="rutube.length > 0" :class="activeTab === 1 ? 'active-tab' : ''" @click="setActive(1)">
          <span class="video-tab__count">{{ rutube.length }}</span><span
            class="video-tab__label">RUTUBE</span>
        </div>
        <div class="video-tab" v-if="vk.length > 0" :class="activeTab === 2 ? 'active-tab' : ''" @click="setActive(2)">
          <span class="video-tab__count">{{ vk.length }}</span><span
            class="video-tab__label">VK</span>
        </div>
      </div>

      <video-item v-bind:videos="youtube" :postfix="'y'" v-show="activeTab === 0"/>

      <video-item v-bind:videos="rutube" :postfix="'r'" v-if="activeTab === 1"/>

      <video-item v-bind:videos="vk" :postfix="'v'" :is-list="true" v-show="activeTab === 2"/>

    </div>
  </div>
</template>

<script>

import {RUTUBE, VK, YOUTUBE} from '@/common/videoType'
import VideoItem from "./VideoItem";

export default {
  name: 'product-video',
  components: {
    VideoItem
  },
  props: {
    product_id: {
      require: true
    }
  },
  data: () => ({
    youtube: [],
    rutube: [],
    vk: [],
    show: false,
    activeTab: YOUTUBE,
    loading: true
  }),
  created() {
    this.$api.product.video(this.product_id).then((response) => {
      this.loading = false
      if (response && response.data) {
        this.show = response.data.length > 0
        this.youtube = response.data.filter((item) => item.type === YOUTUBE)
        this.rutube = response.data.filter((item) => item.type === RUTUBE)
        this.vk = response.data.filter((item) => item.type === VK)

        if (!this.youtube.length && this.rutube.length) {
          this.activeTab = RUTUBE;
        } else if (!this.youtube.length && this.vk.length) {
          this.activeTab = VK;
        }
        this.loading = false
      }
    }).catch(() => {
      this.loading = false
    })
  },
  methods: {
    setActive(tab) {
      this.activeTab = tab
    },
  }
}
</script>